// @ts-strict-ignore

export const tooltipZIndexModifiers = {
  // needed in order for reactstrap tooltips to appear above CL components
  setZIndex: {
    enabled: true,
    fn: componentData => ({
      ...componentData,
      styles: {
        ...componentData.styles,
        zIndex: 'var(--cl-zindex-tooltip)',
      },
    }),
  },
};
